import React, { useState } from 'react';
import { money } from 'src/utils/format';
// eslint-disable-next-line no-restricted-imports
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { CombinationBetState } from './CombinationBet.state';
import { TypeId } from 'src_common/common/websocket2/type';
import { FreeBetSelector, FreeBetType } from './BonusEngineFreeBets/FreeBetSelector';
import { AvailableFreeBetType } from './BonusEngineFreeBets/FreeBetSelector.state';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { useCommon } from 'src/AppState/Common';

export interface PropsInnerType {
    assignedToMe: boolean | null | undefined;
    bet: unknown;
    combinations: unknown;
    currency: unknown;
    focusedBet: unknown;
    legs: unknown;
    onBlur: () => void;
    onChange: (body: { stakePerLine?: string; eachWay?: boolean }) => void;
    onFocus: () => void;
    onRemove: () => void;
    bonusEngineFreeBets: Array<FreeBetType>;
    selectedFreeBets: Array<AvailableFreeBetType>;
    toggleFreeBet: (freeBet: AvailableFreeBetType) => void;
    clearFreeBetSelection: () => void;
    userId: number;
}

export const CombinationBetNew = observer((propsIn: PropsInnerType) => {
    const props = useAsObservableSource(propsIn);
    const { websocketV2 } = useAppStateContext();
    const [combinationBetState] = useState(() => new CombinationBetState(props));
    const common = useCommon();
    const { config } = ConfigState.get(common);

    const {
        stakePerLine,
        onChangeStakePerLine,
        isFocused,
        isReferred,
        hasSP,
        currencySymbol,
        combinationFound,
        possibleReturns,
        price,
        cleanStake,
        bet,
        legsForCombination,
        currency,
        saveStake,
        remove,
        handleBlur,
        handleFocus,
        assignedToMe,
        onChangeEachWay,
        errorBlackBox,
        betBonusEngineFreeBets,
    } = combinationBetState;

    if (bet === null) {
        return null;
    }

    return (
        <li
            className={`betslip-leg--multiple ${isFocused ? 'betslip-leg--marked' : ''}`}
            onMouseEnter={handleFocus}
            onMouseLeave={handleBlur}
        >
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            {assignedToMe === true || !isReferred ? (
                <a
                    href='#'
                    className='betslip-leg-remove'
                    onClick={remove}
                >
                    &times;
                </a>
            ) : null}

            <div className='betslip-leg-amount'>
                <div
                    className='row'
                    title={errorBlackBox}
                >
                    <div
                        className='col-6'
                        style={errorBlackBox === undefined ? {} : { color: 'red' }}
                    >
                        {hasSP ? 'n/a' : price}
                    </div>
                    <div className='col-6'>
                        <div className='element'>
                            <span className='prefix'>{currencySymbol}</span>
                            <input
                                type='text'
                                value={stakePerLine}
                                onChange={onChangeStakePerLine}
                                onBlur={saveStake}
                                onClick={cleanStake}
                                data-test={`${bet.name}-stake-input`}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <span className='betslip-leg-name'>
                {isReferred && combinationFound !== null
                    ? `${combinationFound.name}(${combinationFound.numLines})`
                    : `${bet.name}(${bet.numLines})`}
                <br />
                {Object.values(legsForCombination).map((leg) => {
                    if (leg.eventId === undefined || leg.marketId === undefined || leg.selectionId === undefined) {
                        return null;
                    }
                    const price = leg.priceType === 'sp' ? 'SP' : (leg.price ?? 'n/a');
                    const selection = websocketV2.getSelectionAndLoad(
                        TypeId.newMarketId(leg.eventId, leg.marketId),
                        leg.selectionId
                    );

                    if (selection !== null) {
                        return <small key={selection.id}>{`${selection.name} ( ${price} )`}</small>;
                    }
                })}
            </span>

            <div className='betslip-leg-returns'>
                Possible returns: {money(possibleReturns, currency?.value ?? null)}
                {bet.maxStake !== undefined && <div>Cust. max bet: {money(bet.maxStake, currency?.value ?? null)}</div>}
                {betBonusEngineFreeBets.some((fb) => fb.freeBets.length > 0) && config.showBonusEngine === true && (
                    <FreeBetSelector
                        betUid={bet.uid}
                        betType={bet.type}
                        userId={props.userId}
                        bonusEngineFreeBets={betBonusEngineFreeBets}
                        currency={typeof currency === 'string' ? currency : ''}
                        currencySymbol={currencySymbol}
                        selectedFreeBets={props.selectedFreeBets}
                        toggleFreeBet={props.toggleFreeBet}
                        clearFreeBetSelection={props.clearFreeBetSelection}
                    />
                )}
            </div>

            {(bet.ewOffered !== undefined || Boolean(bet.eachWay)) &&
            bet.type !== 'FC' &&
            bet.type !== 'RFC' &&
            bet.type !== 'CFC' &&
            bet.type !== 'TC' &&
            bet.type !== 'CTC' ? (
                <div className='betslip-leg-options'>
                    <label className='checkbox betslip__each-way'>
                        <input
                            type='checkbox'
                            checked={bet.eachWay}
                            onChange={onChangeEachWay}
                        />{' '}
                        EW
                    </label>
                </div>
            ) : null}
        </li>
    );
});
